export default __webpack_public_path__ + "static/media/480_dummy2016-yoga02-mobile-de.b34e44b2.png";